import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Adds a default error handler to all requests.
 */
@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private notification: NzNotificationService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(error => this.errorHandler(error)));
  }

  // Customize the default error handler here
  private errorHandler(error: HttpEvent<any>): Observable<HttpEvent<any>> {

    if (error instanceof HttpErrorResponse) {
      switch ((error as HttpErrorResponse).status) {
        case 400:
          return this.handleError(error);
        case 401:
          return this.handle401Error(error);
        case 404:
          return this.handleError(error);
        case 500:
          return this.handleError(error);
        default:
          return throwError(error);
      }
    }

    return throwError(error);
  }

  private handleError(error: HttpErrorResponse): Observable<never> {

    const { validation } = error.error.error;

    console.error('Request error', error);
    if (validation){
      this.notification.create('error', `Erro ${error.status}`, validation.join('<br>'));
    }else{
      this.notification.create( 'error', `Erro ${error.status}`, error.error.message );
    }
    this.spinner.hide();

    return throwError(error);
  }

  private handle401Error(error: HttpErrorResponse): Observable<never> {

    console.error('Request error (401)', error);
    this.notification.create( 'error', 'Usuário não autorizado', error.error.message );

    localStorage.removeItem('currentUser');
    this.spinner.hide();
    this.router.navigate(['login']);

    return throwError(error);
  }

}
